export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative w-full min-h-screen flex items-center pt-[72px] overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20warm%20coral%20and%20dark%20gradient%20background%20with%20cinematic%20atmosphere%2C%20soft%20geometric%20shapes%2C%20modern%20streaming%20platform%20aesthetic%2C%20deep%20contrast%20with%20warm%20accents%2C%20subtle%20film%20texture%20overlay%2C%20dark%20edges%20with%20centered%20warm%20glow%2C%20no%20text%2C%20minimalist%20yet%20dramatic&width=1600&height=900&seq=hero-bg-bale-01&orientation=landscape"
          alt="芭乐视频背景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/55"></div>
      </div>

      <div className="relative w-full px-4 md:px-6 py-16 md:py-20 max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 text-primary-300 text-xs font-medium mb-6">
              <i className="ri-fire-fill text-sm"></i>
              聚合平台
              <span className="w-1 h-1 rounded-full bg-primary-400"></span>
              高清观影
              <span className="w-1 h-1 rounded-full bg-primary-400"></span>
              免费在线
            </span>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight">
              芭乐视频
              <br className="sm:hidden" />
              <span className="text-primary-400">红桃·樱花·糖豆</span>
              <br />
              特色视频平台高清免费聚合
            </h1>

            <p className="mt-4 text-lg md:text-xl text-white/70 font-heading italic">
              全网特色视频平台一站聚合，不缓冲畅享高清体验
            </p>

            <p className="mt-6 text-sm md:text-base text-background-300 leading-relaxed max-w-xl mx-auto lg:mx-0">
              芭乐视频精心聚合红桃视频、樱花视频、糖豆视频等热门特色视频平台内容，覆盖最新电视剧全集、热门电影大全，提供高清免费在线观看服务。持续追踪各平台更新动态，精选优质资源，确保流畅不缓冲的观影体验。无论追逐最新剧集还是寻找经典佳作，这里都是您的一站式视频入口。
            </p>

            <div className="mt-8 flex flex-wrap items-center gap-6 justify-center lg:justify-start">
              <div className="flex items-center gap-2">
                <div className="w-9 h-9 rounded-full bg-accent-500/20 flex items-center justify-center">
                  <i className="ri-global-line text-accent-400 text-base"></i>
                </div>
                <div className="text-left">
                  <p className="text-white font-semibold text-sm whitespace-nowrap">覆盖 6+ 特色平台</p>
                  <p className="text-background-400 text-xs">红桃·樱花·糖豆等</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-9 h-9 rounded-full bg-secondary-500/20 flex items-center justify-center">
                  <i className="ri-refresh-line text-secondary-400 text-base"></i>
                </div>
                <div className="text-left">
                  <p className="text-white font-semibold text-sm whitespace-nowrap">每日更新 200+ 资源</p>
                  <p className="text-background-400 text-xs">实时追踪各平台</p>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-9 h-9 rounded-full bg-accent-500/20 flex items-center justify-center">
                  <i className="ri-speed-mini-line text-accent-400 text-base"></i>
                </div>
                <div className="text-left">
                  <p className="text-white font-semibold text-sm whitespace-nowrap">高清流畅不卡顿</p>
                  <p className="text-background-400 text-xs">优化链路保障</p>
                </div>
              </div>
            </div>

            <div className="mt-10 flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <a
                href="#index"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-fill text-lg"></i>
                立即观影
              </a>
              <a
                href="#ranking"
                className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full border-2 border-white/30 text-white font-semibold text-sm hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-lg"></i>
                热门推荐
              </a>
            </div>
          </div>

          <div className="flex-1 w-full flex justify-center lg:justify-end">
            <div className="relative w-full max-w-[480px] aspect-[4/3] rounded-2xl overflow-hidden border border-white/10 shadow-lg">
              <img
                src="https://readdy.ai/api/search-image?query=Cinematic%20film%20collage%20with%20warm%20coral%20and%20deep%20dark%20tones%2C%20movie%20poster%20montage%20style%2C%20dramatic%20lighting%20with%20soft%20glow%2C%20modern%20streaming%20platform%20visual%2C%20abstract%20cinematic%20composition%20with%20film%20grain%20texture%2C%20dark%20background%20with%20warm%20highlight%20accents%2C%20no%20recognizable%20faces%2C%20artistic%20blur%20movement&width=960&height=720&seq=hero-main-bale-01&orientation=landscape"
                alt="芭乐视频主题视觉 - 红桃视频樱花视频糖豆视频聚合"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/30 via-transparent to-transparent"></div>
              <div className="absolute bottom-4 left-4 right-4 flex items-center gap-3">
                <div className="flex-1 h-1.5 rounded-full bg-white/20 overflow-hidden">
                  <div className="h-full w-[65%] rounded-full bg-primary-500"></div>
                </div>
                <span className="text-xs text-white/70 whitespace-nowrap">65%</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}